import './VersionListItem.scss';

export { default } from './VersionListItem';
